// 此文件专门负责项目的路由

import VueRouter from "vue-router"

// 引入组件
import Login from '../views/user/Login'
import NavBar from '../views/home/NavBar'
import UserManage from '../views/home/UserManage'
import PersonRate from '../views/home/PersonRate'
import PersonSingleRate from '../views/home/PersonSingleRate'
import SignRate from "../views/home/SignRate.vue"
import ProductIndex from "../views/home/ProductIndex.vue"
import ProductDetail from "../views/home/ProductDetail.vue"
import ProductRanks from "../views/home/ProductRanks.vue"
import OrderList from "../views/home/OrderList.vue"
import InventoryList from "../views/home/InventoryList.vue"
import InventorySelfList from "../views/home/InventorySelfList.vue"
import { Message } from "element-ui";

// 创建并暴露一个路由器
const router = new VueRouter({
    mode: 'history',    // 路由模式，该模式不会在地址中显示井号#
    routes: [
        {
            path: '/',          // 路径
            redirect: '/login'  // 重定向
        },
        {
            path: '/login',     // 路径
            component: Login    // 跳转到的组件
        },
        {
            path: '/nav-bar',     // 根路径
            component: NavBar,    // 使用NavBar作为父组件
            children: [
                {
                    path: '/nav-bar/user-manage',     // 子路径 /user-manage
                    component: UserManage    // 跳转到的组件
                },
                {
                    path: '/nav-bar/person-rate',     // 子路径 /person-rate
                    component: PersonRate    // 跳转到的组件
                },
                {
                    path: '/nav-bar/person-single-rate',     // 子路径 /person-rate
                    component: PersonSingleRate    // 跳转到的组件
                },
                {
                    path: '/nav-bar/sign-rate',     // 子路径 /person-rate
                    component: SignRate    // 跳转到的组件
                },
                {
                    path: '/nav-bar/product-index',     // 子路径 /person-rate
                    component: ProductIndex    // 跳转到的组件
                },
                {
                    path: '/nav-bar/product-detail',     // 子路径 /person-rate
                    component: ProductDetail    // 跳转到的组件
                },
                {
                    path: '/nav-bar/product-ranks',     // 子路径 /product-ranks
                    component: ProductRanks    // 跳转到的组件
                },
                {
                    path: '/nav-bar/order-list',     // 子路径 /product-ranks
                    component: OrderList    // 跳转到的组件
                },
                {
                    path: '/nav-bar/inventory-list',     // 子路径 /product-ranks
                    component: InventoryList    // 跳转到的组件
                },
                {
                    path: '/nav-bar/inventory-list-self',     // 子路径 /product-ranks
                    component: InventorySelfList    // 跳转到的组件
                },
            ]
        },
        {
            path: '/product-detail',     // 直接访问产品详情页的路径
            component: ProductDetail    // 跳转到的组件
        }
    ]
})

// 导航守卫，前置处理
router.beforeEach((to, from, next) => {
    let isAuthenticated = !!localStorage.getItem('userInfo')
    // 如果路由要跳转到除了登录和注册的界面的话就判断是否已经登录，如果没有登录就强制跳到登录界面
    if (to.path !== '/login' && !isAuthenticated) {
        next({ path: '/login' })
        Message({
            message: '请先登录！',
            type: "warning",
        });
    }
    // 检查用户管理页面的权限
    else if (to.path === '/nav-bar/user-manage') {
        try {
            const userInfoStr = localStorage.getItem('userInfo')
            if (userInfoStr) {
                const userInfo = JSON.parse(userInfoStr)
                
                if (userInfo.isAdmin) {
                    next()
                } else {
                    next({ path: '/nav-bar/home' })
                    Message({
                        message: '您没有权限访问用户管理页面！',
                        type: "warning",
                    });
                }
            } else {
                next({ path: '/login' })
            }
        } catch (error) {
            console.error('解析用户信息失败:', error)
            next({ path: '/login' })
        }
    }
    else next()
})

export default router;